import React from 'react';

import OrderDetailComponent from './OrderDetailComponent';

import './index.scss';

const AppointmentEdl = () => {
  return (
    <div className="edl_container">
      <OrderDetailComponent />
    </div>
  );
};

export default AppointmentEdl;
